import classNames from "classnames";
import { TotalBalanceGlobalMarketCardProps } from "./types";
import { CardContainer } from "@letsbit/milkylb";
import { FormattedMessage } from "react-intl";
import { messages } from "./messages";
import { Link } from "react-router-dom";
import { FormatedValue } from "components/FormatedValue";
import { ReactComponent as DetailsIcon } from "assets/images/icons/limits.svg";
import { ReactComponent as HistoryIcon } from "assets/images/icons/history-purple.svg";
import { Tooltip } from "antd";

export const TotalBalanceGlobalMarketCard: React.FC<
  TotalBalanceGlobalMarketCardProps
> = ({ uid, totalBalance, currency, disabled, className }) => {
  return disabled ? (
    <CardContainer
      className={classNames(
        "dashboard-page fadeIn m-2 h-[181px] w-[345px] rounded-3xl bg-white p-6",
        className,
      )}
    >
      <div className="flex h-full w-full flex-col items-start justify-between">
        <h2 className="font-['Tomato_Grotesk'] text-lg font-bold text-[--milkylb-color-neutral-600]">
          <FormattedMessage {...messages.totalBalance} />
        </h2>
        <div className="flex h-full w-full flex-row items-center justify-center gap-1">
          <p className="font-['Tomato_Grotesk'] text-3xl font-bold text-[--milkylb-color-neutral-400]">
            <FormattedMessage {...messages.accountNotCreated} />
          </p>
        </div>
      </div>
    </CardContainer>
  ) : (
    <Link to={`/logged/members/${uid}/global-market/balance`}>
      <CardContainer
        className={classNames(
          "dashboard-page fadeIn m-2 h-[181px] w-[345px] rounded-3xl bg-white p-6",
          className,
        )}
      >
        <div className="flex h-full w-full flex-col items-start justify-between">
          <h2 className="font-['Tomato_Grotesk'] text-lg font-bold text-[--milkylb-color-neutral-600]">
            <FormattedMessage {...messages.totalBalance} />
          </h2>
          <div className="flex w-full flex-row items-end gap-1">
            <p className="font-['Tomato_Grotesk'] text-3xl font-bold text-[--milkylb-color-neutral-800]">
              <FormatedValue value={totalBalance} />{" "}
            </p>
            <p className="font-['Tomato_Grotesk'] text-sm font-bold text-[--milkylb-color-neutral-800]">
              {currency?.toUpperCase() || ""}
            </p>
          </div>
          <div className="flex w-full flex-row items-center justify-end gap-4">
            <Tooltip title={<FormattedMessage {...messages.buttonDetail} />}>
              <DetailsIcon width={24} height={24} />
            </Tooltip>
            <Tooltip title={<FormattedMessage {...messages.buttonHistory} />}>
              <Link to={`/logged/members/${uid}/global-market/history`}>
                <HistoryIcon width={24} height={24} />
              </Link>
            </Tooltip>
          </div>
        </div>
      </CardContainer>
    </Link>
  );
};
